import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorOption from './../ConfiguratorOption'
import X46MK2TransomConfiguratorImage from './X46MK2TransomConfiguratorImage'
import X46MK2ConfiguratorImage from './X46MK2ConfiguratorImage'
import Toggle from '../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView05ImageOptions } from './views/ExteriorView05'

class X46MK2BathingPlatform extends Component {
  constructor (props) {
    super(props)
    this.handleBathingPlatformChange =
      this.handleBathingPlatformChange.bind(this)
  }

  handleBathingPlatformChange (event) {
    let configuration = this.props.configuration
    configuration.BathingPlatform = event.target.checked
      ? this.props.bathingPlatformOptions[2]
      : this.props.bathingPlatformOptions[1]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView05ImageOptions
    const bathingPlatformOn =
      this.props.configuration.BathingPlatform.value === 3

    let image = bathingPlatformOn ? (
      <X46MK2ConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    ) : (
      <X46MK2TransomConfiguratorImage
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2700, height: 660 }}
        transform={[
          0.104828, 0.022198, 0, -5.9e-5, 0.018392, 0.172197, 0, 5.0e-5, 0, 0,
          1, 0, 149.236483, 260.65591, 0, 1
        ]}
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Bathing platform' />
          </h1>

          <p>
            <Trans
              defaults='The X4<sup>6</sup> features an optional bathing platform which is operated electrically, integrated attachment for “hang on” bathing ladder with {{wood}} steps.'
              values={{
                wood:
                  this.props.configuration.TeakDeck.value === 1
                    ? ' teak'
                    : 'flexiteek'
              }}
            />
          </p>

          <Toggle
            checked={this.props.configuration.BathingPlatform.value === 3}
            onChange={this.handleBathingPlatformChange}
          >
            <Trans defaults='Bathing platform' />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2BathingPlatform)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2BathingPlatform.js